// Avis clientes de la fiche produit : « Voir plus », photos en grand, formulaire « Write a review ».
// Les photos sont réduites à 1600 px (JPEG) avant l'envoi pour rester sous la limite de l'API.
const MAX_PHOTOS = 3;
const MAX_SIDE = 1600;

async function shrink(file) {
  const bitmap = await createImageBitmap(file);
  const scale = Math.min(1, MAX_SIDE / Math.max(bitmap.width, bitmap.height));
  const canvas = document.createElement('canvas');
  canvas.width = Math.round(bitmap.width * scale);
  canvas.height = Math.round(bitmap.height * scale);
  canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height);
  bitmap.close?.();
  const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.85));
  if (!blob) throw new Error('photo');
  return new File([blob], file.name.replace(/\.\w+$/, '') + '.jpg', { type: 'image/jpeg' });
}

for (const root of document.querySelectorAll('[data-elirati-reviews]')) {
  if (root.dataset.ready) continue;
  root.dataset.ready = '1';
  const perPage = Number(root.dataset.perPage) || 6;
  const messages = JSON.parse(root.querySelector('[data-review-messages]').textContent);

  // Voir plus
  root.querySelector('[data-review-more]')?.addEventListener('click', (event) => {
    const hidden = [...root.querySelectorAll('.el-review[hidden]')];
    hidden.slice(0, perPage).forEach((li) => li.removeAttribute('hidden'));
    if (hidden.length <= perPage) event.currentTarget.parentElement.remove();
  });

  // Photos en grand
  const lightbox = root.querySelector('[data-review-lightbox]');
  const lightboxImg = root.querySelector('[data-review-lightbox-img]');
  root.addEventListener('click', (event) => {
    const photo = event.target.closest('[data-photo]');
    if (!photo) return;
    lightboxImg.src = photo.dataset.photo;
    lightbox.showModal();
  });

  // Formulaire
  const dialog = root.querySelector('[data-review-dialog]');
  const form = root.querySelector('[data-review-form]');
  const done = root.querySelector('[data-review-done]');
  const error = root.querySelector('[data-review-error]');
  const submit = root.querySelector('[data-review-submit]');
  const input = root.querySelector('[data-review-photos]');
  const previews = root.querySelector('[data-review-previews]');
  const label = submit.textContent;
  let photos = [];

  for (const d of [dialog, lightbox]) d.addEventListener('click', (event) => { if (event.target === d) d.close(); });
  document.querySelectorAll('[data-review-open]').forEach((b) => b.addEventListener('click', () => {
    form.hidden = false;
    done.hidden = true;
    dialog.showModal();
  }));

  const showError = (key) => {
    error.textContent = messages[key] || messages.server;
    error.hidden = false;
  };

  input.addEventListener('change', async () => {
    error.hidden = true;
    const files = [...input.files].slice(0, MAX_PHOTOS - photos.length);
    input.value = '';
    for (const file of files) {
      try {
        photos.push(await shrink(file));
      } catch {
        showError('photos');
      }
    }
    previews.replaceChildren(...photos.map((file, i) => {
      const wrap = document.createElement('span');
      wrap.className = 'el-form__preview';
      const img = document.createElement('img');
      img.src = URL.createObjectURL(file);
      img.alt = '';
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.textContent = '×';
      remove.setAttribute('aria-label', 'Remove');
      remove.addEventListener('click', () => {
        photos.splice(i, 1);
        wrap.remove();
        input.dispatchEvent(new Event('change'));
      });
      wrap.append(img, remove);
      return wrap;
    }));
    input.disabled = photos.length >= MAX_PHOTOS;
  });

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    error.hidden = true;
    if (!form.querySelector('[name="rating"]:checked')) return showError('rating');
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }
    const data = new FormData(form);
    data.delete('photos');
    photos.forEach((p) => data.append('photos', p));
    submit.disabled = true;
    submit.textContent = messages.sending;
    try {
      const res = await fetch(root.dataset.endpoint, { method: 'POST', body: data });
      const body = await res.json().catch(() => ({}));
      if (!res.ok) return showError(body.error === 'invalid' && body.field === 'rating' ? 'rating' : body.error);
      form.reset();
      photos = [];
      previews.replaceChildren();
      input.disabled = false;
      form.hidden = true;
      done.hidden = false;
    } catch {
      showError('server');
    } finally {
      submit.disabled = false;
      submit.textContent = label;
    }
  });
}
